const tabs = {
    introduction: 0,
    information: 1,
    questionnaire: 2,
    camera: 3,
    summary: 4,
};

export default tabs;
